import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import "./App.css";
import ProductList from "./components/Products/ProductList";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import NotFound from "./components/NotFound";
import LoadingSpinner from "./UI/LoadingSpinner";

const Faq = React.lazy(() => import("./components/Faq"));


function App() {
  return (
   
    <>
    <Suspense 
      fallback={
      <div className="centerednotfound">
        <LoadingSpinner />
      </div>
    }>
      <Switch>
      <Route path="/" exact>
        <Navbar />
        <p className="affiliate">Affiliate disclosure. As an Amazon Assciate, we may earn
commisions from qualifying purchases from Amazon.com</p>
        <ProductList />
        <Footer />
      </Route>
      <Route path="/faq">
        <Faq />
      </Route>
      <Route path="*">
        <NotFound/>
      </Route>
      </Switch>
      </Suspense>
    </>
    
  );
}

export default App;

/*
      <Switch>
          <Route path="/" component={App} exact />
          <Route path="/faq" component={faq} />
          <Route component={Error} />
      </Switch>

*/


/*

      <div>
     <Switch>
          <Route path="/" component={App} exact />
          <Route path="/faq" component={faq} />
          <Route component={Error} />
      </Switch>
      </div>


      */